import { render } from "./howitwork.vue?vue&type=template&id=335b2d73"
import script from "./howitwork.vue?vue&type=script&lang=js"
export * from "./howitwork.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__